export default "__VITE_ASSET__Bd2VMdgK__"